import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export function useTransactionCategoryUtils() {
  const { t } = useTranslation();

  const getTransactionCategoryLabel = useCallback(
    (transactionCategory: string) => {
      switch (transactionCategory) {
        case 'INTERNAL_TRANSFER':
          return t('Internal transfer');
        case 'EXTERNAL_TRANSFER':
          return t('External transfer');
        case 'OTHER':
          return t('Other');
        default:
          return t('Unknown');
      }
    },
    [t],
  );

  return { getTransactionCategoryLabel };
}
